import { SvgIcon } from "@mui/material";

const User = (props) => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path d="M8,8a4,4,0,1,1,4,4A4,4,0,0,1,8,8ZM19.89,18.55l-1.44-2.89A3,3,0,0,0,15.76,14H8.24a3,3,0,0,0-2.69,1.66L4.11,18.55A1,1,0,0,0,5,20H19A1,1,0,0,0,19.89,18.55Z" />
    </SvgIcon>
  );
};

export default User;
